import { Input as BaseInput, type InputProps } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { controlStateTarget, controlThemeStyle } from '../form.css';
import { textareaStyle } from './Textarea.css';

type Props = InputProps & {
  maxLength?: number;
  rows?: number;
};

export const Textarea = ({ rows = 4, ...delegated }: Props) => {
  return (
    <BaseInput
      {...delegated}
      className={clsxs(controlStateTarget, textareaStyle, delegated.className)}
      render={(inputProps) => (
        <div className={controlThemeStyle}>
          <textarea {...inputProps} rows={rows} />
        </div>
      )}
    />
  );
};
